import { render, staticRenderFns } from "./RectangleSolidIcon.vue?vue&type=template&id=200adf41&"
import script from "./RectangleSolidIcon.vue?vue&type=script&lang=js&"
export * from "./RectangleSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports